import React from 'react';
import Select from '../../../components/ui/Select';

import Icon from '../../../components/AppIcon';

const SortingControls = ({ sortBy, onSortChange, viewMode, onViewModeChange }) => {
  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant' },
    { value: 'alphabetical', label: 'Alphabetical (A-Z)' },
    { value: 'alphabetical-desc', label: 'Alphabetical (Z-A)' },
    { value: 'status', label: 'Booth Status' },
    { value: 'visitors', label: 'Most Visited' },
    { value: 'recent', label: 'Recently Added' }
  ];

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 md:gap-4 mb-4 md:mb-6">
      <div className="flex items-center gap-2">
        <Icon name="ArrowUpDown" size={18} color="var(--color-muted-foreground)" />
        <span className="text-sm md:text-base text-muted-foreground">Sort by:</span>
      </div>
      
      <div className="flex items-center gap-3 w-full sm:w-auto">
        <div className="flex-1 sm:flex-initial sm:w-48">
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={onSortChange}
          />
        </div>
        
        <div className="hidden md:flex items-center gap-2 border border-border rounded-lg p-1">
          <button
            onClick={() => onViewModeChange('grid')}
            className={`p-2 rounded transition-smooth ${
              viewMode === 'grid' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:bg-muted'
            }`}
            aria-label="Grid view"
          >
            <Icon name="LayoutGrid" size={18} />
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`p-2 rounded transition-smooth ${
              viewMode === 'list' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:bg-muted'
            }`}
            aria-label="List view"
          >
            <Icon name="List" size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SortingControls;